import { z } from "zod";
import {
    ChartDetail,
    ChartDraftData,
    ChartPermissionOutput,
    ChartPermissionRole,
    ChartPermissionTarget,
    ChartSummary,
    ChartType,
    ChartVersionOutput,
} from "../chart.js";

export const schema = {
    list: {
        input: z.object({
            page: z.coerce.number().int().min(0).optional().default(0),
            pageSize: z.coerce.number().int().min(1).optional().default(10),
            search: z.coerce.string().optional(),
        }),
        output: z.object({
            charts: z.array(ChartSummary),
            total: z.number(),
            totalFound: z.number(),
        }),
    },
    get: {
        input: z.object({ id: z.number() }),
        output: ChartDetail.nullable(),
    },
    create: {
        input: z.object({
            title: z.string().min(1).max(255),
            description: z.string().max(1000).optional(),
            permissions: z
                .array(
                    z.object({
                        role: ChartPermissionRole,
                        target: ChartPermissionTarget,
                        userId: z.number().optional(),
                        organizationId: z.number().optional(),
                    }),
                )
                .optional(),
        }),
        output: ChartSummary,
    },
    update: {
        input: z.object({
            id: z.number(),
            title: z.string().min(1).max(255).optional(),
            description: z.string().max(1000).nullable().optional(),
        }),
        output: z.void(),
    },
    delete: {
        input: z.object({ id: z.number() }),
        output: z.boolean(),
    },
    saveDraft: {
        input: z.object({
            id: z.number(),
            data: ChartDraftData,
        }),
        output: z.void(),
    },
    commitVersion: {
        input: z.object({
            id: z.number(),
            label: z.string().min(1).max(255),
            defaultChartType: ChartType.optional(),
        }),
        output: ChartVersionOutput,
    },
    getVersion: {
        input: z.object({
            chartId: z.number(),
            versionId: z.number(),
        }),
        output: ChartVersionOutput.nullable(),
    },
    restoreVersion: {
        input: z.object({
            chartId: z.number(),
            versionId: z.number(),
        }),
        output: z.void(),
    },
    getVersionThread: {
        input: z.object({ versionId: z.number() }),
        output: z.object({
            threadId: z.number(),
        }),
    },
    addPermission: {
        input: z.object({
            chartId: z.number(),
            role: ChartPermissionRole,
            target: ChartPermissionTarget,
            userId: z.number().optional(),
            organizationId: z.number().optional(),
        }),
        output: ChartPermissionOutput,
    },
    removePermission: {
        input: z.object({
            chartId: z.number(),
            permissionId: z.number(),
        }),
        output: z.boolean(),
    },
    updatePermission: {
        input: z.object({
            permissionId: z.number(),
            role: ChartPermissionRole,
        }),
        output: ChartPermissionOutput,
    },
};
